import * as React from "react";
import { Box, Modal as MUIModal } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "transparent",

  width: "100%",
  maxWidth: "562px",
  padding: "16px",
};

export default function Modal({
  open = true,
  children = null,
  handleClose = () => {},
  maxWidth = "562px",
}) {
  return (
    <MUIModal
      open={open}
      onClose={handleClose}
      sx={{ padding: 0 }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ ...style, maxWidth }}>{children}</Box>
    </MUIModal>
  );
}
